import React from 'react'
import './Sidebar.css'

export default function Sidebar(props) {
    return(
        <nav className={props.class}>
            <ul className="sidebar-head">
                {props.title.map((obj, index) => {
                    return <li className={props.itemClass[index]} key={index}><a href={`#item${index}`}>{obj}</a></li>
                })}
            </ul>
        </nav>
    )
}